<template>
    <div>
        <transition name="slide-up">
            <section class="floating-buy" v-show="salesButtonSeen">
                <div class="floating-buy__price">
                    <template v-if="defaultPaymentMethod === 'null'">
                        <open-checkout-popup>
                            <p v-if="!removeOriginalPrice" class="floating-buy__old-price">
                                {{ $t('sales.normally') }}
                                <span class="striketrought"><product-price field="original"></product-price></span>
                            </p>
                            <h4 v-if="removeScarcity" class="floating-buy__now-price">
                                {{ $t('sales.only') }}
                                <span class="price"><product-price field="full"></product-price></span>
                            </h4>
                            <h4 v-else class="floating-buy__now-price">
                                {{ ctaFirstWord }} {{ $t('sales.only') }}
                                <span class="price"><product-price field="full"></product-price></span>
                            </h4>
                        </open-checkout-popup>
                    </template>
                    <template v-else @click="scrollToPaymentBlock">
                        <div class="floating-buy__cursor" @click="scrollToPaymentBlock">
                            <p v-if="!removeOriginalPrice" class="floating-buy__old-price">
                                {{ $t('sales.normally') }}
                                <span class="striketrought"><product-price field="original"></product-price></span>
                            </p>
                            <h4 class="floating-buy__now-price">
                                {{ ctaFirstWord }} {{ $t('sales.only') }}
                                <span class="price"><product-price field="full"></product-price></span>
                            </h4>
                        </div>
                    </template>
                </div>
                <open-checkout-popup v-if="defaultPaymentMethod === 'null'">
                    <div class="floating-buy__button" v-html="ctaButtonText"></div>
                </open-checkout-popup>
                <div v-else class="floating-buy__button" @click="scrollToPaymentBlock" v-html="ctaButtonText"></div>
            </section>
        </transition>
    </div>
</template>

<script>
import { fixedTopBarMixin } from '../mixins/fixedTopBarMixin';
import { mapGetters, mapState } from 'vuex';

export default {
    data: function () {
        return {
            ctaFirstWord: 'Today',
        };
    },
    props: {
        ctaButton: {},
    },
    mixins: [fixedTopBarMixin],
    computed: {
        ...mapGetters(['product']),
        ...mapState([
            'salesButtonSeen',
            'defaultPaymentMethod',
            'isUpsell',
            'removeOriginalPrice',
            'removeLowestBeforePrice',
            'removeScarcity',
        ]),
        ctaButtonText() {
            return this.ctaButton;
        },
    },
    watch: {
        salesButtonSeen: function (value) {
            if (value) {
                const cookieBanner = document.getElementById('cm');
                if (cookieBanner) {
                    cookieBanner.classList.add('show-spacer');
                }
                document.getElementById('floating-sales-button-spacer').classList.add('show-spacer');
            }
        },
    },
    mounted: function () {
        if (this.isUpsell) {
            this.ctaFirstWord = this.$t('sales.onThisPage');
        }
    },
};
</script>
